import {ITableColumn} from '../../types';
import {ReactNode} from 'react';

export type PlaybookDimension = { name: string, value: string }

export enum PlaybookStatus {
    ACTIVE = 'ACTIVE',
    DRAFT = 'DRAFT',
    DEPRECATED = 'DEPRECATED',
}

export type Playbook = {
    id: string,
    name?: string,
    displayName?: string,
    description?: string,
    stateMachineArn?: string,
    inputSchema?: string,
    category?: string,
    status?: PlaybookStatus,
    createdByUsername?: string,
    createdBy?: { givenName: string, familyName: string },
    created?: string,
    updated?: string,
}


export interface IPlaybookTableColumn extends ITableColumn {
    render?: (item: Playbook) => ReactNode;
}

export type PlaybookRecordFormProps = {
    record: Playbook,
    handleSubmit: (values: Playbook) => void
    handleCancel: () => void
}


export type ListPlaybooks = {
    // FNP-565: `nextToken` is the token-pagination cursor. It is nullable —
    // absent means the server has no further pages, which is what
    // getNextPageParam turns into `undefined` to stop the infinite query.
    listPlaybooks: { items: Playbook[], nextToken?: string | null }
}

export type GetPlaybook = {
    getPlaybook: Playbook
}

export type CreatePlaybook = {
    createPlaybook: Playbook
}

export type UpdatePlaybook = {
    updatePlaybook: Playbook
}

export type DeletePlaybook = {
    deletePlaybook: string
}

// FNP-1011: the full tree, for export. Kept separate from `Playbook` because
// only the export path asks for phases and steps.
export type PlaybookExportStep = {
    id: string
    phaseId: string
    name: string
    displayName?: string | null
    description?: string | null
    position: number
    taskStateName?: string | null
    targetService?: string | null
    targetOperation?: string | null
    // AWSJSON — arrives DOUBLE-WRAPPED from AppSync. See
    // utils/playbookDefinition.ts for why, and do not unwrap it here.
    parameters?: string | null
}

export type PlaybookExportPhase = {
    id: string
    name: string
    displayName?: string | null
    description?: string | null
    position: number
    steps?: PlaybookExportStep[] | null
}

export type PlaybookWithPhases = Playbook & {
    phases?: PlaybookExportPhase[] | null
}

export type GetPlaybookForExport = {
    getPlaybook: PlaybookWithPhases
}

export type ImportPlaybookResult = {
    id: string
    name: string
    phaseCount: number
    stepCount: number
}

export type ImportPlaybook = {
    importPlaybook: ImportPlaybookResult
}
